module.exports = __webpack_public_path__ + "img/partner9.dcbc0b27.png";